
export default function SQLs_Create_DB() {
  return (
    <div>
      <h1>SQL Create DB</h1>
      <p>Content for SQL Create DB will go here.</p>
    </div>
  );
}
